import { Course, User } from "@/interface/myClass";
import { myClass } from "@/services/View Class/fetchMyClass";
import { getUploadUrl } from "@/utils/api";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useMyClass = () => {
  const navigate = useNavigate();
  const [myCourses, setMyCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const defaultImage = "/buku2.png";

  useEffect(() => {
    const fetchMyClasses = async () => {
      try {
        const parsedUser: User = JSON.parse(
          localStorage.getItem("user") ?? "{}",
        );
        const { id } = parsedUser;
        const token = localStorage.getItem("token");

        if (!token || !id) {
          setError("User tidak ditemukan. Silakan login kembali.");
          setLoading(false);
          return;
        }

        const data = await myClass({ id, token, setError });

        setMyCourses(data?.data ?? []);
      } catch (err: unknown) {
        setError("Gagal memuat data kelas.");
      } finally {
        setLoading(false);
      }
    };

    fetchMyClasses();
  }, []);

  const handleDownloadCertificate = async (
    serverFilename: string,
    courseId: number,
    courseTitle: string,
    userName: string,
  ) => {
    setDownloadingId(courseId);
    try {
      const safeTitle = (courseTitle || "Course").replace(/[\\/:*?"<>|]/g, "-");
      const safeUser = (userName || "Student").replace(/[\\/:*?"<>|]/g, "-");
      const fileUrl = getUploadUrl(`uploads/certificates/${serverFilename}`);

      const response = await axios.get(fileUrl, { responseType: "blob" });

      const extension = serverFilename.split(".").pop() || "pdf";
      const newFilename = `Sertifikat - ${safeTitle} - ${safeUser}.${extension}`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", newFilename);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Gagal mengunduh:", err);
      alert(
        "Gagal mengunduh. File fisik sertifikat tidak ditemukan di server.",
      );
    } finally {
      setDownloadingId(null);
    }
  };

  return {
    myCourses,
    loading,
    error,
    downloadingId,
    defaultImage,
    navigate,
    handleDownloadCertificate,
  };
};
